module.exports = __webpack_public_path__ + "img/cresc_3.90d9abb3.png";